import React, { Component, useContext } from "react";
import { Dropdown } from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";
import { decodeToken } from "react-jwt";
import Dashboard from "../../services/Idea.API/Dashboard";
import Context from "../../Context/UserContext";
import ContentUrls from "./ContentUrls";

import {
  CLAIM_CODCUSTOMER,
  CLAIM_ROLE_ADMIN,
  getInfoToken,
  keyAccess,
} from "../../Utils/RoleHelper";
var codCustomer;
const urls = [
  { to: "Reportablidad", name: "Reportabilidad" },
  { to: "ReportablidadDimensiones", name: "Reportabilidad Dimensiones" },
  { to: "ReportablidadArea", name: "Reportabilidad Área" },
  { to: "ReportablidadGerencia", name: "Reportabilidad Gerencia" },
  { to: "RatioParticipantes", name: "Ratio por Participantes" },
]

const urlsDesafio = [
  { to: "desafio/Reportablidad", name: "Reportabilidad" },
  { to: "desafio/ReportablidadDimensiones", name: "Reportabilidad Dimensiones" },
  { to: "desafio/ReportablidadArea", name: "Reportabilidad Área" },
  { to: "desafio/ReportablidadGerencia", name: "Reportabilidad Gerencia" },
  { to: "desafio/RatioParticipantes", name: "Ratio por Participantes" },
]
class Header extends Component {
  static contextType = Context; // Asigna el contexto a una propiedad estática

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      logout: "",
      token: window.localStorage.getItem("jwt"),
      //obj: {},
      obj: JSON.parse(window.localStorage.getItem(keyAccess)),
      perfilFoto: {},
      isAdmin: false,
      isCollapseOneOpen: false, // Controla si "Ideas" está abierto o cerrado
      isCollapseOpen: false,
    };
    if (this.state.token != null) {
      codCustomer = getInfoToken(this.state.token, CLAIM_CODCUSTOMER);
      var rol = decodeToken(this.state.token);
      if (rol == null) {
        window.localStorage.removeItem("jwt");
        window.history.push("/login");
      }
      if (rol.role != null) {
        var array = rol.role;
        this.state.obj["gerencia"] = array[0];
        this.state.obj["rol"] = array[1];
      }
      if (this.state.obj.role.includes(CLAIM_ROLE_ADMIN)) {
        this.state.isAdmin = true;
      } else {
        this.state.isAdmin = false;
      }
      console.log(this.state.isAdmin);
    }
  }

  async componentWillMount() {
    const { logoutHandler } = this.context; // Obtiene el método logoutHandler del contexto
    this.setState({ logoutHandler }); // Guarda el método en el estado si es necesario

    const response = await Dashboard.getPerfil();
    this.setState({ perfilFoto: response });
  }
  handleSubmit(e) {
    e.preventDefault();
    const { logoutHandler } = this.context; // Obtiene el método logoutHandler del contexto
    window.localStorage.removeItem("jwt");
    window.localStorage.removeItem("username");
    window.sessionStorage.clear();
    this.props.history.push("/login");
    window.location.reload();
    logoutHandler();
  }

  toggleCollapseOne = () => {
    this.setState(prevState => ({
      isCollapseOneOpen: !prevState.isCollapseOneOpen,
      // Si "Ideas" se abre, cierra "Desafios"
      isCollapseOpen: false,
    }));
  };

  // Método para alternar el estado de "Desafios"
  toggleCollapse = () => {
    this.setState(prevState => ({
      isCollapseOpen: !prevState.isCollapseOpen,
      // Si "Desafios" se abre, cierra "Ideas"
      isCollapseOneOpen: false,
    }));
  };

  render() {
    return (
      <div className="horizontal-menu">
        <nav
          className="navbar top-navbar default-layout-navbar col-lg-12 col-12 p-0 d-flex flex-row"
          style={{
            borderBottom: "4px solid #b39e60",
            background: codCustomer === "19" ? "#BC9E54" : "",
            zIndex: "1000",
          }}
        >
          <div className="container">
            <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
              {/* <Link className="navbar-brand brand-logo" to="/"><img src={'https://www.goldfields.com.pe/images/logo-gold-fields-small.png'} alt="logo" /></Link> */}
              {/* <Link className="navbar-brand brand-logo-mini" to="/"><img src={'https://www.goldfields.com.pe/images/logo-gold-fields-small.png'} alt="logo" /></Link> */}
            </div>
            <div className="navbar-menu-wrapper d-flex align-items-stretch justify-content-end">
              <ul className="navbar-nav navbar-nav-right">
                <li className="nav-item mr-1"></li>
                {/* <li className="nav-item">
                  <Dropdown alignRight>
                    <Dropdown.Toggle className="nav-link count-indicator">
                      <i className="ti-bell mx-0"></i>
                      <span className="count"></span>
                    </Dropdown.Toggle>
                  </Dropdown>
                </li> */}
                <li className="nav-item nav-profile">
                  <Dropdown alignRight>
                    <Dropdown.Toggle className="nav-link count-indicator">
                      <img
                        src={
                          this.state.perfilFoto?.fotoUrl === null
                            ? require("../../../assets/images/perfil_prueba.jpg")
                            : this.state.perfilFoto?.fotoUrl
                        }
                        alt="profile"
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="preview-list navbar-dropdown">
                      <Link
                        className="dropdown-item preview-item"
                        to={"/perfil"}
                      >
                        <div className="d-flex align-items-center">
                          <i className="ti-user text-primary"></i>
                          <span className="pl-2">Perfil</span>
                        </div>
                      </Link>
                      <Dropdown.Item
                        className="dropdown-item preview-item"
                        onClick={this.handleSubmit}
                      >
                        <div className="d-flex align-items-center">
                          <i className="ti-power-off text-primary"></i>
                          <span className="pl-2">Cerrar Sesión</span>
                        </div>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
              </ul>
              <button
                className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
                type="button"
                onClick={this.toggleBottomMenu}
              >
                <span className="ti-menu"></span>
              </button>
            </div>
          </div>
        </nav>
        <nav className="bottom-navbar">
          <div className="container">
            <ul className="nav page-navigation">
              <li
                className={
                  this.isPathActive("/cuadrodemando")
                    ? "nav-item active"
                    : "nav-item"
                }
              >
                <Link className="nav-link" to="/cuadrodemando">
                  <i className="ti-home menu-icon"></i>
                  <span className="menu-title">Cuadro Mando</span>
                </Link>
              </li>
              <li
                className={
                  this.isPathActive("/basic-ui")
                    ? "nav-item mega-menu active"
                    : this.isPathActive("/advanced-ui")
                    ? "nav-item mega-menu active"
                    : this.isPathActive("/icons")
                    ? "nav-item mega-menu active"
                    : "nav-item mega-menu"
                }
              >
                <div href="#" className="nav-link">
                  <i className="fa fa-lightbulb-o menu-icon"></i>
                  {codCustomer == 19 ? (
                    <span className="menu-title">Ideas de Oro</span>
                  ) : (
                    <span className="menu-title">Ingenio</span>
                  )}
                  <i className="menu-arrow"></i>
                </div>
                <div className="submenu" style={{ zIndex: "1000" }}>
                  <div className="col-group-wrapper row">
                    <div
                      className={
                        //this.state.obj.rol === "Admin"
                        this.state.isAdmin 
                          ?  codCustomer == 19 ?  "col-group col-md-3" : "col-group col-md-5"
                          :  codCustomer == 19 ?  "col-group col-md-4" : "col-group col-md-9"
                      }


                    >
                      <div className="row">
                        <div className="col-12">
                          <p className="category-heading">Usuarios</p>
                          <div className="submenu-item">
                            <div className="row">
                              <div className={ codCustomer==19 ?  "col-md-12" :"col-md-6" }>
                                <ul>
                                  <li className="nav-item">
                                    {" "}
                                    <Link
                                      className={
                                        this.isPathActive("/cuadrodemando")
                                          ? "nav-link active"
                                          : "nav-link"
                                      }
                                      to="/cuadrodemando"
                                    >
                                      Cuadro Mando
                                    </Link>
                                  </li>
                                  {codCustomer == 19 && (
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive("/desafios/lista")
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/desafios/lista"
                                      >
                                        Todos los Desafíos
                                      </Link>
                                    </li>
                                  )}
                                  {codCustomer == 19 && (
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive(
                                            "/paqueteCriterios/lista"
                                          )
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/MisDesafios/lista"
                                      >
                                        Mis desafios
                                      </Link>
                                    </li>
                                  )}
                                  {codCustomer == 19 && this.state.isAdmin && (
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive(
                                            "/paqueteCriterios/lista"
                                          )
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/paqueteCriterios/lista"
                                      >
                                        Paquete de Criterios
                                      </Link>
                                    </li>
                                  )}

                                  <li className="nav-item">
                                    {" "}
                                    <Link
                                      className={
                                        this.isPathActive("/idea/misideas")
                                          ? "nav-link active"
                                          : "nav-link"
                                      }
                                      to="/idea/misideas"
                                    >
                                      Mis Ideas
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    {" "}
                                    <Link
                                      className={
                                        this.isPathActive("/ideas/lista")
                                          ? "nav-link active"
                                          : "nav-link"
                                      }
                                      to="/ideas/lista"
                                    >
                                      Todas las Ideas
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    {" "}
                                    <Link
                                      className={
                                        this.isPathActive(
                                          "/idea/listapremiospersona"
                                        )
                                          ? "nav-link active"
                                          : "nav-link"
                                      }
                                      to="/idea/listapremiospersona"
                                    >
                                      Canjear Premios
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    {" "}
                                    <Link
                                      className={
                                        this.isPathActive("/ideas/catalogo")
                                          ? "nav-link active"
                                          : "nav-link"
                                      }
                                      to="/ideas/catalogo"
                                    >
                                      Catálogo de Premios
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                 {codCustomer !=  19 && <div className="col-md-6">
                                <ul>
                                  <li className="nav-item">
                                    {" "}
                                    <Link
                                      className={
                                        this.isPathActive("/Reportablidad")
                                          ? "nav-link active"
                                          : "nav-link"
                                      }
                                      to="/Reportablidad"
                                    >
                                      Reportabilidad
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    {" "}
                                    <Link
                                      className={
                                        this.isPathActive(
                                          "/ReportablidadDimensiones"
                                        )
                                          ? "nav-link active"
                                          : "nav-link"
                                      }
                                      to="/ReportablidadDimensiones"
                                    >
                                      Reportabilidad Dimensiones
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    {" "}
                                    <Link
                                      className={
                                        this.isPathActive("/ReportablidadArea")
                                          ? "nav-link active"
                                          : "nav-link"
                                      }
                                      to="/ReportablidadArea"
                                    >
                                      Reportabilidad Área
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    {" "}
                                    <Link
                                      className={
                                        this.isPathActive(
                                          "/ReportablidadGerencia"
                                        )
                                          ? "nav-link active"
                                          : "nav-link"
                                      }
                                      to="/ReportablidadGerencia"
                                    >
                                      Reportabilidad Gerencia
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    {" "}
                                    <Link
                                      className={
                                        this.isPathActive("/RatioParticipantes")
                                          ? "nav-link active"
                                          : "nav-link"
                                      }
                                      to="/ratioParticipantes"
                                    >
                                      Ratio por Participantes
                                    </Link>
                                  </li>
                                </ul>
                              </div> }
                              
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    

               {codCustomer == 19  &&   <div className="col-group col-md-3" >
                      <div className="row">
                        <div className="col-12">
                          <p className="category-heading">Reportabilidad</p>
                          <div className="submenu-item">
                            <div className="row">
                              <div className="col-md-12">                             
{
                                  <div style={{width:'100%'}}>
                                    <div
                                      onClick={this.toggleCollapseOne}
                                      href="#" className="nav-item"
                                      style={{ display: 'flex', gap: '10px', alignItems: 'center', cursor: 'pointer' }}
                                    >
                                      <i className={`fa-solid ${this.state.isCollapseOneOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                                      <span className="menu-title">Ideas</span>
                                    </div>
                                    <div
                                      id="collapseOne"
                                      className={`accordion-collapse collapse ${this.state.isCollapseOneOpen ? 'show' : ''}`}
                                    >
                                      <div className="accordion-body">
                                        <ContentUrls urls={urls} />
                                      </div>
                                    </div>
                                    <br />

                                    <div
                                      onClick={this.toggleCollapse}
                                      href="#" className="nav-item" style={{ display: 'flex', gap: '10px', alignItems: 'center', cursor: 'pointer' }}
                                    >
                                      <i className={`fa-solid ${this.state.isCollapseOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                                      <span className="menu-title">Desafíos</span>
                                    </div>
                                    <div
                                      id="collapse"
                                      className={`accordion-collapse collapse ${this.state.isCollapseOpen ? 'show' : ''}`}
                                    >
                                      <div className="accordion-body">
                                        <ContentUrls urls={urlsDesafio} />
                                      </div>
                                    </div>
                                  </div>
  }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> }
                  

                    <div className="col-group col-md-2">
                      <div className="row">
                        <div className="col-12">
                          <p className="category-heading">Comité</p>
                          <div className="submenu-item">
                            <div className="row">
                              <div className="col-md-12">
                                <ul>
                                  <li className="nav-item">
                                    {" "}
                                    <Link
                                      className={
                                        this.isPathActive(
                                          "/ideass/userevaluador"
                                        )
                                          ? "nav-link active"
                                          : "nav-link"
                                      }
                                      to="/ideass/userevaluador"
                                    >
                                      Comité Evaluador
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* {this.state.obj.rol === "Admin" ? ( */}
                    {this.state.isAdmin ? (
                      <div className="col-group col-md-4">
                        <div className="row">
                          <div className="col-12">
                            <p className="category-heading">Administrador</p>
                            <div className="submenu-item">
                              <div className="row">
                                <div className="col-md-6">
                                  <ul>
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive("/Interacciones")
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/Interacciones"
                                      >
                                        Interacción Sesión
                                      </Link>
                                    </li>
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive(
                                            "/ReportablidadInteracion"
                                          )
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/ReportablidadInteracion"
                                      >
                                        Interacción Módulos
                                      </Link>
                                    </li>
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive("/listaPersonas")
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/listaPersonas"
                                      >
                                        Canjear Premios{" "}
                                      </Link>
                                    </li>
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive("/momentos")
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/momentos"
                                      >
                                        Momentos
                                      </Link>
                                    </li>
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive("/premios/catalogo")
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/premios/catalogo"
                                      >
                                        Catálogo de Premios
                                      </Link>
                                    </li>
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive(
                                            "/idea/listapremiosadmin"
                                          )
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/idea/listapremiosadmin"
                                      >
                                        Solicitud de Premios
                                      </Link>
                                    </li>
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive("/organigrama")
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/organigrama"
                                      >
                                        Organigrama
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                                <div className="col-md-6">
                                  <ul>
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive("/Seguimiento")
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/Seguimiento"
                                      >
                                        Seguimiento Idea
                                      </Link>
                                    </li>
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive(
                                            "/ideas/createIdeaAdmin"
                                          )
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/ideas/createIdeaAdmin"
                                      >
                                        Crear Idea
                                      </Link>
                                    </li>
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive(
                                            "/ideas/listaUsuarios"
                                          )
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/ideas/listaUsuarios"
                                      >
                                        Lista Usuarios
                                      </Link>
                                    </li>
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive("/ideas/revision")
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/ideas/revision"
                                      >
                                        Revisión de Ideas
                                      </Link>
                                    </li>
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive(
                                            "/ideass/comiteevaluador"
                                          )
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/ideass/comiteevaluador"
                                      >
                                        Comité Evaluador
                                      </Link>
                                    </li>
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive(
                                            "/ideas/evaluaciones"
                                          )
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/ideas/evaluaciones"
                                      >
                                        Ideas Sustentadas
                                      </Link>
                                    </li>
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive(
                                            "/ideas/gestionPlataforma"
                                          )
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/ideas/gestionPlataforma"
                                      >
                                        Gestión Plataforma
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      " "
                    )}
                  </div>
                </div>
              </li>
              {codCustomer == 2 && (
                <>
                 <li
                    className={
                      this.isPathActive("/rutina")
                        ? "nav-item active"
                        : "nav-item"
                    }
                  >
                    <Link className="nav-link" to="/rutina">
                      <i className="ti-bar-chart-alt menu-icon"></i>
                      <span className="menu-title">{`${
                        codCustomer == 2
                          ? "Gestión de la Disciplina"
                          : "Gestión de la Rutina"
                      }`}</span>
                    </Link>
                  </li>
                  <li
                    className={
                      this.isPathActive("/fortaleciendoVinculos")
                        ? "nav-item active"
                        : "nav-item"
                    }
                  >
                    <Link className="nav-link" to="/fortaleciendoVinculos">
                      <i className="fa icon-link menu-icon"></i>
                      <span className="menu-title">Fortaleciendo Vínculos</span>
                    </Link>
                  </li>
                 
                </>
              )}
              {codCustomer != 2 && (
                <li
                  className={
                    this.isPathActive("/fortaleciendoVinculos")
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <Link className="nav-link" to="/fortaleciendoVinculos">
                    <i className="fa icon-link menu-icon"></i>
                    <span className="menu-title">Fortaleciendo Vínculos</span>
                  </Link>
                </li>
              )}

              {codCustomer != 2 && (
                <li
                  className={
                    this.isPathActive("/rutina")
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <Link className="nav-link" to="/rutina">
                    <i className="ti-bar-chart-alt menu-icon"></i>
                    <span className="menu-title">{`${
                      codCustomer == 2
                        ? "Gestión de la Disciplina"
                        : "Gestión de la Rutina"
                    }`}</span>
                  </Link>
                </li>
              )}

              {codCustomer != 2 && (
                <li
                  className={
                    this.isPathActive("/basic-ui")
                      ? "nav-item mega-menu active"
                      : this.isPathActive("/advanced-ui")
                      ? "nav-item mega-menu active"
                      : this.isPathActive("/icons")
                      ? "nav-item mega-menu active"
                      : "nav-item mega-menu"
                  }
                >
                  <div href="#" className="nav-link">
                    <i className="ti-clipboard menu-icon"></i>
                    <span className="menu-title">Compromisos para Mejorar</span>
                    <i className="menu-arrow"></i>
                  </div>
                  <div
                    className={
                      this.state.isAdmin
                        ? "submenu col-9 ml-auto"
                        : "submenu col-8 ml-auto"
                    }
                  >
                    <div className="col-group-wrapper row">
                      <div
                        className={
                          this.state.isAdmin
                            ? "col-group col-md-4"
                            : "col-group col-md-6"
                        }
                      >
                        <div className="row">
                          <div className="col-12">
                            <p className="category-heading">Usuarios</p>
                            <div className="submenu-item">
                              <div className="row">
                                <div className="col-md-12">
                                  <ul>
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive(
                                            "/compromisos/dashboard"
                                          )
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/compromisos/dashboard"
                                      >
                                        Cuadro de Mando
                                      </Link>
                                    </li>
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive("/createcompromiso")
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/createcompromiso"
                                      >
                                        Crear Compromiso
                                      </Link>
                                    </li>
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive(
                                            "/compromisosPersonales"
                                          )
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/compromisosPersonales"
                                      >
                                        Mis Compromisos
                                      </Link>
                                    </li>
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive("/compromisos")
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/compromisos"
                                      >
                                        Compromisos del Área
                                      </Link>
                                    </li>
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive(
                                            "/compromisos/verificacion"
                                          )
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/compromisos/verificacion"
                                      >
                                        Verificar Compromisos{" "}
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          this.state.isAdmin
                            ? "col-group col-md-4"
                            : "col-group col-md-6"
                        }
                      >
                        <div className="row">
                          <div className="col-12">
                            <p className="category-heading">Históricos</p>
                            <div className="submenu-item">
                              <div className="row">
                                <div className="col-md-12">
                                  <ul>
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive(
                                            "/compromisos/historico"
                                          )
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/compromisos/historico"
                                      >
                                        Histórico de Mis Compromisos
                                      </Link>
                                    </li>
                                    <li className="nav-item">
                                      {" "}
                                      <Link
                                        className={
                                          this.isPathActive("/compromisos/area")
                                            ? "nav-link active"
                                            : "nav-link"
                                        }
                                        to="/compromisos/historico/area"
                                      >
                                        Histórico de Compromisos - Área
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {this.state.isAdmin ? (
                        <div className="col-group col-md-4">
                          <div className="row">
                            <div className="col-12">
                              <p className="category-heading">Administrador</p>
                              <div className="submenu-item">
                                <ul>
                                  <li className="nav-item">
                                    {" "}
                                    <Link
                                      className={
                                        this.isPathActive(
                                          "/compromisos/historico/total"
                                        )
                                          ? "nav-link active"
                                          : "nav-link"
                                      }
                                      to="/compromisos/historico/total"
                                    >
                                      Todos los Compromisos
                                    </Link>
                                  </li>
                                  <li className="nav-item">
                                    {" "}
                                    <Link
                                      className={
                                        this.isPathActive(
                                          "/compromisos/historico/gerencia"
                                        )
                                          ? "nav-link active"
                                          : "nav-link"
                                      }
                                      to="/compromisos/historico/gerencia"
                                    >
                                      Histórico de Compromisos - Gerencia{" "}
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        " "
                      )}
                    </div>
                  </div>
                </li>
              )}
            </ul>
          </div>
        </nav>
      </div>
    );
  }

  toggleBottomMenu() {
    document.querySelector(".bottom-navbar").classList.toggle("header-toggled");
  }

  toggleRightSidebar() {
    document.querySelector(".right-sidebar").classList.toggle("open");
  }

  componentDidMount() {
    // Horizontal menu fixed when scrolling
    let navbar = document.querySelector(".horizontal-menu");
    let body = document.querySelector("body");
    if (navbar) {
      window.addEventListener("scroll", function () {
        if (window.scrollY >= 70) {
          navbar.classList.add("fixed-on-scroll");
          body.classList.add("horizontal-menu-fixed-on-scroll");
        } else {
          navbar.classList.remove("fixed-on-scroll");
          body.classList.remove("horizontal-menu-fixed-on-scroll");
        }
      });
    }

    // Horizontal menu navigation in mobile menu on click
    let navItemClicked = document.querySelectorAll(
      ".horizontal-menu .page-navigation >.nav-item"
    );
    navItemClicked.forEach(function (el) {
      el.addEventListener("click", function () {
        var result = [],
          node = this.parentNode.firstChild;
        while (node) {
          if (node !== this) result.push(node);
          node = node.nextElementSibling || node.nextSibling;
        }
        result.forEach((el) => el.classList.remove("show-submenu"));
        this.classList.toggle("show-submenu");
      });
    });
  }

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }
}

export default withRouter(Header);
